// Local translations
export const T = {
  en_GB: {
    organizationIdentifier: "Organization Identifier",
    enterOrgIdentifier: "Please enter your organization identifier",
    orgNotFound: "Organization not found",
    enterOrgUniqueId: "Enter your organization's unique identifier",
    checking: "Checking...",
    continue: "Continue",
    ssoNotConfigured: "SSO is not configured for this organization",
    redirecting: "Redirecting...",
    continueWith: "Continue with",
    orContinueWithEmail: "Or continue with email",
    email: "Email",
    password: "Password",
    fillAllFields: "Please fill in all fields",
    signingIn: "Signing in...",
    signIn: "Sign in",
    forgotPassword: "Forgot password?",
    loginFailed: "Login failed",
    invalidCredentials: "Invalid credentials",
    ssoLoginFailed: "SSO login failed",
  },
  nb_NO: {
    organizationIdentifier: "Organisasjonsidentifikator",
    enterOrgIdentifier: "Vennligst oppgi organisasjonsidentifikatoren din",
    orgNotFound: "Organisasjon ikke funnet",
    enterOrgUniqueId: "Oppgi organisasjonens unike identifikator",
    checking: "Sjekker...",
    continue: "Fortsett",
    ssoNotConfigured: "SSO er ikke konfigurert for denne organisasjonen",
    redirecting: "Omdirigerer...",
    continueWith: "Fortsett med",
    orContinueWithEmail: "Eller fortsett med e-post",
    email: "E-post",
    password: "Passord",
    fillAllFields: "Vennligst fyll ut alle felt",
    signingIn: "Logger inn...",
    signIn: "Logg inn",
    forgotPassword: "Glemt passord?",
    loginFailed: "Innlogging mislyktes",
    invalidCredentials: "Ugyldige innloggingsopplysninger",
    ssoLoginFailed: "SSO-innlogging mislyktes",
  },
} as const;
